import { DevHubDynamicIcon, DevHubIconButton } from '@devxdiscover/devhub-ui';

import { MyApp } from './types/myAppTypes';

interface Props {
  app: MyApp;
  onStarChange: (appId: number, isStarred: boolean) => void;
}

/**
 * ToggleStar adds a star component to an app that can be toggled on or off
 * @param props props of the component
 * @param props.app the application to star or unstar
 * @param props.onStarChange function to call when the star is toggled
 */
function ToggleStar(props: Props) {
  const { app, onStarChange } = props;

  const toggleStar = () => {
    const entityRef = Number(app.applicationId);
    const currentArray = localStorage.getItem('starredApplications');
    const newArray = currentArray ? JSON.parse(currentArray) : [];

    const index = newArray.indexOf(entityRef);
    if (index !== -1) {
      // Remove the ID if it already exists
      newArray.splice(index, 1);
    } else {
      // Add the ID if it doesn't exist
      newArray.push(entityRef);
    }

    localStorage.setItem('starredApplications', JSON.stringify(newArray));
    onStarChange(app.applicationId, !app.isStarred);
  };

  return (
    <DevHubIconButton
      onClick={(e: {
        preventDefault: () => void;
        stopPropagation: () => void;
      }) => {
        e.preventDefault();
        e.stopPropagation();
        toggleStar();
      }}
    >
      <DevHubDynamicIcon
        iconName="StarSharp"
        fontSize="large"
        color={app.isStarred ? 'gold' : 'disabled'}
      />
    </DevHubIconButton>
  );
}

export default ToggleStar;
